import { startCase } from 'lodash';
import { entityTypeNameFor } from './entity-type-name-for';
export var entityLabel = function (entity) {
  var schema = entity && entity._schema || {};
  return schema.label || startCase(entityTypeNameFor(entity));
};